/* tslint:disable */
/* eslint-disable */
/**
 * Atelier Roles API
 * L\'Atelier des rôles (BO admin) : référentiel des briques (standard verrouillées, personnalisées administrables), profils (ensembles de rôles appliqués à la création des acteurs) et matrice rôles/portails. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PermissionItemDto
 */
export interface PermissionItemDto {
    /**
     * 
     * @type {string}
     * @memberof PermissionItemDto
     */
    nom: string;
    /**
     * 
     * @type {string}
     * @memberof PermissionItemDto
     */
    libelle?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionItemDto
     */
    accordee: boolean;
}

/**
 * Check if a given object implements the PermissionItemDto interface.
 */
export function instanceOfPermissionItemDto(value: object): value is PermissionItemDto {
    if (!('nom' in value) || value['nom'] === undefined) return false;
    if (!('accordee' in value) || value['accordee'] === undefined) return false;
    return true;
}

export function PermissionItemDtoFromJSON(json: any): PermissionItemDto {
    return PermissionItemDtoFromJSONTyped(json, false);
}

export function PermissionItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PermissionItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'nom': json['nom'],
        'libelle': json['libelle'] == null ? undefined : json['libelle'],
        'accordee': json['accordee'],
    };
}

export function PermissionItemDtoToJSON(json: any): PermissionItemDto {
    return PermissionItemDtoToJSONTyped(json, false);
}

export function PermissionItemDtoToJSONTyped(value?: PermissionItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nom': value['nom'],
        'libelle': value['libelle'],
        'accordee': value['accordee'],
    };
}

